
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class InvoiceCompanyDialog extends Serenity.EntityDialog<InvoiceCompanyRow, any> {
        protected getFormKey() { return InvoiceCompanyForm.formKey; }
        protected getIdProperty() { return InvoiceCompanyRow.idProperty; }
        protected getLocalTextPrefix() { return InvoiceCompanyRow.localTextPrefix; }
        protected getNameProperty() { return InvoiceCompanyRow.nameProperty; }
        protected getService() { return InvoiceCompanyService.baseUrl; }
        protected getDeletePermission() { return InvoiceCompanyRow.deletePermission; }
        protected getInsertPermission() { return InvoiceCompanyRow.insertPermission; }
        protected getUpdatePermission() { return InvoiceCompanyRow.updatePermission; }

        protected form = new InvoiceCompanyForm(this.idPrefix);

    }
}